import GenericStateHelper from '../lib/generic-state-helper';

export const APP_NAMESPACE = 'APP';

const stateAppError = new GenericStateHelper(APP_NAMESPACE, 'APP_ERROR');
const stateAppErrorDialog = new GenericStateHelper(
  APP_NAMESPACE,
  'APP_ERROR_DIALOG'
);
const stateAppConfirmDialog = new GenericStateHelper(
  APP_NAMESPACE,
  'APP_CONFIRM_DIALOG'
);
const stateImpersonate = new GenericStateHelper(APP_NAMESPACE, 'IMPERSONATE');

const ERROR_DIALOG_NAME = 'errorDialog';
const CONFIRM_DIALOG_NAME = 'confirmDialog';
const APP_ERROR = 'appException';
const IMPERSONATE = 'impersonate';

export const AppStore = {
  getReducers() {
    return {
      [stateAppErrorDialog.getActionName()]: (state, errorDialogObj) => ({
        ...state,
        [ERROR_DIALOG_NAME]: {
          ...errorDialogObj,
        },
      }),
      [stateAppConfirmDialog.getActionName()]: (state, confirmDialogObj) => ({
        ...state,
        [CONFIRM_DIALOG_NAME]: {
          ...confirmDialogObj,
        },
      }),
      [stateAppError.getActionName()]: (state, error) => ({
        ...state,
        [APP_ERROR]: {
          ...error,
        },
      }),
      [stateImpersonate.getActionName()]: (state, impersonateObj) => ({
        ...state,
        [IMPERSONATE]: impersonateObj,
      }),
    };
  },
  initTalentAppState: () => () =>
    Promise.all([
      // getBarredLocations(),
    ]).then(() => {
      // PreloadedBarredLocationsStore.load();
      return null;
    }),

  actionShowStoreError(errorMessage) {
    return stateAppError.actionSet({ errorMessage });
  },
  actionShowErrorDialog(errorTitle, errorDescription) {
    return stateAppErrorDialog.actionSet({ errorTitle, errorDescription });
  },

  actionShowConfirmDialog({
    bodyText,
    headerText,
    onConfirmClick = () => {},
    onCancelClick = () => {},
    showCancelButton = false,
    cancelButtonText = 'Cancel',
    confirmButtonText = 'Confirm',
  } = {}) {
    return stateAppConfirmDialog.actionSet({
      bodyText,
      headerText,
      onConfirmClick,
      onCancelClick,
      showCancelButton,
      cancelButtonText,
      confirmButtonText,
    });
  },
  actionImpersonateCandidate(candidateId) {
    return stateImpersonate.actionSet({ candidateId });
  },

  actionClearErrorDialog() {
    return stateAppErrorDialog.actionSet({});
  },
  actionClearConfirmDialog() {
    return stateAppConfirmDialog.actionSet({});
  },

  selectAppError(state) {
    return stateAppError.select(state)[APP_ERROR];
  },
  selectErrorDialog(state) {
    return stateAppErrorDialog.select(state)[ERROR_DIALOG_NAME];
  },
  selectConfirmDialog(state) {
    return stateAppConfirmDialog.select(state)[CONFIRM_DIALOG_NAME];
  },
  selectImpersonatingCandidateId(state) {
    return stateImpersonate.select(state)[IMPERSONATE]
      ? stateImpersonate.select(state)[IMPERSONATE].candidateId
      : null;
  },
};
